<template>
  <v-list
    dense
    light
    class="pt-0"
  >
    <template v-for="item in items">
      <v-list-item
        v-if="!item.subItems"
        :key="item.title"
        :to="{ name: item.routeName }"
        no-action
      >
        <v-list-item-icon>
          <v-icon v-text="item.action" />
        </v-list-item-icon>
        <v-list-item-title
          class="pl-4"
          v-text="item.title"
        />
      </v-list-item>

      <v-list-group
        v-else
        :key="item.title"
        v-model="item.active"
        :prepend-icon="item.action"
        no-action
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item
          v-for="subItem in item.subItems"
          :key="subItem.text"
          :to="subItem.routeName ? { name: subItem.routeName } : ''"
        >
          <v-list-item-content>
            <v-list-item-title>{{ subItem.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </template>
  </v-list>
</template>

<script>
export default {
  props: ["items"],
};
</script>
